import { DeviceType, EcsDevice } from 'shared/models';
import { DeviceStatus } from 'ui/shared/deviceStatus';
import { DeviceStatus as _DeviceStatus } from 'shared/models';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Dictionary } from 'lodash';

require('./DeviceLineItem.css');

export type Props = {
    deviceTypes: Dictionary<DeviceType>;
    device: EcsDevice;
    online: boolean | null;
    busy: boolean;
    showRemove: boolean;
    showAssign: boolean;
    showDelete: boolean;
    onAssign?(): void;
    onRemove?(): void;
    onDelete?(): void;
};

export const DeviceLineItem = ({ deviceTypes, device, online, showRemove, showAssign, showDelete, busy, onAssign, onRemove, onDelete }: Props) => {
    const { t } = useTranslation();
    const deviceType = deviceTypes && deviceTypes[device.deviceTypeId];
    const modelName = deviceType ? deviceType.displayName : device.deviceTypeId;
    const { regCode } = device.properties;

    return (
        <div
            id={ `dli${device.deviceId}` }
            className="device-line-item"
        >
            <span>
                { <DeviceStatus status={ online === null ? null : online ? _DeviceStatus.Up : _DeviceStatus.Down }/> }
            </span>
            <span>
                <span>
                    { modelName }
                </span>
                <span style={ { opacity: .666, marginLeft: '.75em', fontFamily: 'monospace' } }>
                    { device.macAddress }
                </span>
                { regCode &&
                    <Link to={ `/setup/${regCode}` }>
                        <span className="reg-code-link" >
                            { regCode }
                        </span>
                    </Link>
                }
                { showRemove &&
                    <button
                        type="button"
                        className="ui tiny grey icon basic button"
                        disabled={ busy }
                        onClick={ onRemove }
                    >
                        { t('COMMAND.REMOVE') }
                    </button>
                }
                { showAssign &&
                    <button
                        type="button"
                        className="ui tiny grey icon basic button"
                        disabled={ busy }
                        onClick={ onAssign }
                    >
                        { t('COMMAND.ASSIGN') }
                    </button>
                }
                { showDelete &&
                    <button
                        type="button"
                        className="ui tiny red icon basic button"
                        disabled={ busy }
                        onClick={ onDelete }
                    >
                        { t('COMMAND.DELETE') }
                    </button>
                }
            </span>
        </div>
    );
};
